const submissionKey = ({ api }) => JSON.stringify([String(api?.id), api?.attempt ?? api?.submitted_at ?? null]);

export const filterImportableQuizSubmissions = (submissions, batches) => {
    const imported = new Set(
        batches.filter((batch) => !batch.is_failed).flatMap((batch) => (batch.submissions || []).map(submissionKey))
    );
    return submissions.filter((submission) => {
        const key = submissionKey(submission);
        if (imported.has(key)) return false;
        imported.add(key);
        return true;
    });
};

export const getQuizSubmissionProgress = (batches) => {
    const successfulBatches = batches.filter((batch) => !batch.is_failed);
    const processing = successfulBatches.filter((batch) => !batch.is_finished);
    const processed = successfulBatches.reduce((count, batch) => count + (batch.submission_count || 0), 0);
    return {
        processing,
        processingProcessed: processing.reduce((count, batch) => count + (batch.submission_count || 0), 0),
        processingTotal: processing.reduce((count, batch) => count + (batch.submissions?.length || 0), 0),
        processed,
        total: successfulBatches.reduce((count, batch) => count + (batch.submissions?.length || 0), 0),
        failed: batches.some(
            (batch) =>
                batch.is_failed &&
                filterImportableQuizSubmissions(batch.submissions || [], successfulBatches).length > 0
        ),
    };
};
